/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-03-07 10:10:45
 */
export default{
    base:{
        search:'查询',
        add:'新增',
        edit:'编辑',
        save:'保存',
        modify:'修改',
        delete:'删除',
        download:'下载',
        downloadSuccess:'下载成功',
        push:'推送',
        release:'发布',
        use:'启用',
        forbidden:'禁用',
        released:'已发布',
        invalid:'无效',
        test:'测试中',
        customCol:'自定义列',
        person:'个人中心',
        logout:'退出登录',
        login:'登录',
        logoutMsg:'确定退出当前登录？',
        tip:'提示',
        confirm:'确定',
        confirm2:'确认',
        cancel:'取消',
        copy:'复制',
        cancelReplace:'取消更换',
        revokeDelete:'撤销删除',
        reset:'重置',
        yes:'是',
        no:'否',
        YES:'是',
        NO:'否',
        all:'全部',
        uploadFirmware:'上传固件',
        total:'共',
        page:'页',
        row:'条',
        upload:'上传',
        enter:'请输入',
        select:'请选择',
        great:'伟大',
        homeTitle:'的艺术品不必追随潮流，它本身就能引领潮流',
        selectFile:'选择文件',
        selectDateRange:'请选择日期范围',
        noData:'暂无数据',
        noEmpty:'不能为空！',
        dataView:"数据视图",
        downLoad:"下载",
        close:"关闭",
        refresh:'刷新',
        currentDate:'当前时间',
        week:'周',
        order_number:'序号',
        operate:'操作',
        customColumns:'自定义列显示',
        delMsg:'是否确认删除?',
        uploadImg:'上传图片',
        noEmpty:'不能为空!',
        needUploadImg:'请上传图片！',
        addSuccessMsg:'新增成功！',
        editSuccessMsg:'编辑成功！',
        delSuccessMsg:'删除成功！',
        cancelSuccessMsg:'取消成功！',
        saveSuccessMsg:'保存成功！',
        operateSuccessMsg:'操作成功！',
        clearLocalStorage:'清除缓存',
        hasEmptyItem:'存在为空的数据项，请填写后再提交！',
        more:'更多',
        pickDate:"请选择日期",
        summary:'全部汇总',
        weekSummary:'周汇总',
        normal:'正常',
        canceled:'已取消',
        selectConfirmMsg:'是否确定所选项，点击确定将会保存该数据',
        km:'公里',
        top:'排行第',
        export:'导出',
        rollBack:'版本回退',
        nextPage:'下一页',
        prevPage:'上一页',
        total:'总共',
        rows:'条',
        zh:'中文',
        en:'英语',
        de:'德语',
        cancelEdit:'取消编辑',
        finish:'完成',
        fetchTip:'支持模糊搜索',
        downlaoding:'下载中...',
        link:'故障链接',

        enter:'请输入',
    },
    msg:{
        deleteMsg:'是否确认删除？',
        uploadMsg:'固件上传成功！',
        forbiddenMsg:'固件已禁用！',
        releaseMsg:'请选择发布环境！',
        limitMsg:'请选择发布限制！',
        limitValMsg:'请输入发布限制数值！',
        fileMsg:'请选择需上传固件！',
        cancelTip: '是否确认取消？',
        delMsg:'是否确认删除？',
    },
    menu:{
        notice:'公告管理',
        firmware:'固件管理',
        smallProgram:'小程序管理',
        user:'用户管理',
        fault:'故障管理',
        customer:'客户管理',
        code:'编码管理',
        scanRecord:'扫码记录',
        file:'文件管理',
    },
    home:{
        morning:'早上好！',
        forenoon:'上午好！',
        noon:'中午好！',
        afternoon:'下午好！',
        evening:'晚上好！',
        welcome:'欢迎登录！',
    },
    login:{
        user_name:'用户名',
        password:'密码',
        loginBtn:'登录',
        captcha:'验证码',
    },
    notice:{
        list:'公告列表',
        add:'新建公告',
        releaseNotice:'发布公告',
        notice_title:'标题',
        status:'状态',
        create_time:'创建时间',
        cancel_time:'取消时间',
        cancel:'取消',
        detail:'详情',
        notice_title2:'公告标题',
        relateApp:'关联的小程序',
        content:'正文',
        customer_name:'客户名称',
        hardware_platform_name:'硬件平台名称',
        manufacturer_name:'车厂名称',
        model_name:'车型名称',
    },
    firmware:{
        list:'固件列表',
        add:'上传固件',
        hardware_version:'硬件版本',
        software_version:'软件版本',
        file_desc:'固件描述',
        status:'状态',
        environment:'环境',
        customer_code:'客户编码',
        manufacturer_code:'车厂编码',
        model_code:'车型编码',
        hardware_platform_code:'硬件平台编码',
        software_main_version:'软件主版本',
        software_item_version:'软件次版本',
        crc_val:'CRC原始值',
        create_time:'创建时间',
        release:'发布',
        cancel:'取消',
        product:'正式',
        test:'测试',
        
        customer_name:'客户名称',
        manufacturer_name:'车厂名称',
        model_name:'车型名称',
        hardware_platform_name:'硬件平台名称',
    },
    smallProgram:{
        app_id:'app id',
        app_name:'名称',
        status:'状态',
        enable:'启用',
        stop:'禁用',
        add_app:'新增小程序',
        delete:'删除',
    },
    user:{
        editPassword:'修改密码',
        oldPassword:'旧密码',
        newPassword:'新密码',
        
        user_name:'账号',
        full_name:'昵称',
        mobile:'手机号',
        status:'启用状态',
        create_timestamp:'创建时间',
        password:'密码',
        confirm_password:'确认密码',
        normal:'正常',
        stop:'禁用',
        enable:'启用',
        role_type:'角色类型',
        admin:'后台管理员',
        publishedNoticeUser:'公告发布人员',
        fileUploadUser:'文件管理人员',
        add_user:'新增用户',
        app_id_msg:'若无数据，请到【小程序管理】进行维护',
        changeAvatar:'更换头像',
        user_type:'用户类型',
        app:'APP用户',
        backend:'后台用户',
        customer_name:'关联的客户',
    },
    fault:{
        fault_name:'故障名称',
        solution:'解决方案',
        chip_id:'芯片ID',
        create_time:'创建时间',
        file_url:'文件URL',
    },
    customer:{
        customer_name:'客户名称',
        create_time:'创建时间',
        remark:'备注',
    },
    code:{
        app_name:'小程序名称',
        dict_name:'编码名称',
        dict_code:'编码编号',
        dict_type:'编码类型',
        parent_code:'父级编号',
        remark:'备注',
        create_time:'创建时间',
    },
    file:{
        upload:'上传文件',
        category:'文件分类',
        pictures:'图片',
        files:'普通文件',
        selectCategory:'请选择文件分类',
        selectFile:'请选择文件',
        uploadBtn:'上传',
        uploadSuccess:'文件上传成功！',
        file_name:'文件名',
        file_no:'文件编号',
        file_size:'文件大小',
        download_path:'下载路径',
        file_list:'文件列表',
        file_list_placeholder:'文件列表功能开发中...',
        create_time:'创建时间',
        byte:'字节',
    },
}
